import { render, staticRenderFns } from "./split-promotion.vue?vue&type=template&id=41c27ed7"
import script from "./split-promotion.vue?vue&type=script&lang=js"
export * from "./split-promotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports